import baseAPI from "@/http";

const router = "api/CidadeEmpreendedoraNews";

export const cidadeEmpreendedoraNewsAPI = {
  filtros: () => baseAPI.get(`${router}/filtros`),
  gerar: (payload) => baseAPI.post(`${router}/gerar`, payload),
};
